import { Form, useLoaderData } from "react-router-dom"
import StatCard, { SmallStatCard } from "../components/StatCard";
import StatGraph, { DataMaster } from "../components/StatGraph";
import { Select } from "../components/Select";
import { useEffect, useState } from "react";
import { capitalize, formatCurrency, formatDate, getUserId } from "../services/helpers";
import { TextField } from "../components/TextField";
import { Button } from "../components/Button";
import { getDashboardStats, getWahuStats } from "../services/api";
import { LineChart } from "@mui/x-charts";

import "../styles/wahu.css";


export function Wahu() {
	//Display toggles
	// const [momInterval,setMomInterval] = useState("Monthly");
	const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	const loaderData = useLoaderData();

	const data = loaderData.data;


	console.log("data", data);

	const [_showDateFilterPop, _setShowDateFilterPopup] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [showUploadPopup, setShowUploadPopup] = useState(false);
	const [uploadFiles, setUploadFiles] = useState({ file1: null, file2: null });
	const [uploadError, setUploadError] = useState("");
	const [isUploading, setIsUploading] = useState(false);
	const [dragOver, setDragOver] = useState({ file1: false, file2: false });

	const handleDragOver = (e, fileKey) => {
		e.preventDefault();
		e.stopPropagation();
		setDragOver((prev) => ({ ...prev, [fileKey]: true }));
	};

	const handleDragLeave = (e, fileKey) => {
		e.preventDefault();
		e.stopPropagation();
		setDragOver((prev) => ({ ...prev, [fileKey]: false }));
	};

	const handleDrop = (e, fileKey) => {
		e.preventDefault();
		e.stopPropagation();
		setDragOver((prev) => ({ ...prev, [fileKey]: false }));
		const files = e.dataTransfer.files;
		if (files.length > 0) {
			setUploadFiles((prev) => ({ ...prev, [fileKey]: files[0] }));
		}
	};

	const handleBoxClick = async (fileKey) => {
		try {
			const [handle] = await window.showOpenFilePicker({
				startIn: "downloads",
				types: [{ accept: { "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"], "application/vnd.ms-excel": [".xls"], "text/csv": [".csv"] } }],
			});
			const file = await handle.getFile();
			setUploadFiles((prev) => ({ ...prev, [fileKey]: file }));
		} catch {
			const input = document.createElement("input");
			input.type = "file";
			input.accept = ".csv,.xlsx,.xls";
			input.onchange = (e) => {
				if (e.target.files.length > 0) {
					setUploadFiles((prev) => ({ ...prev, [fileKey]: e.target.files[0] }));
				}
			};
			input.click();
		}
	};
	const isLoggedIn = !!localStorage.getItem("token");

	const topCategories = Object.entries(data.categories)
		.sort((a, b) => a[1].occurances - b[1].occurances).reverse().slice(0, 5);

	const topComponents = Object.entries(data.component_stats)
		.sort((a, b) => a[1]["occurance"] - b[1]["occurance"]).reverse().slice(0, 5);

	const handleUploadSubmit = async (e) => {
		e.preventDefault();
		setUploadError("");
		if (!uploadFiles.file1 || !uploadFiles.file2) {
			setUploadError("Please select both files");
			return;
		}
		setIsUploading(true);
		const formData = new FormData();
		formData.append("daily_maintenance", uploadFiles.file1);
		formData.append("bike_journal", uploadFiles.file2);
		try {
			const response = await fetch("api/wahu.php/wahu_upload", {
				method: "POST",
				headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
				body: formData,
			});
			if (response.ok) {
				setShowUploadPopup(false);
				setUploadFiles({ file1: null, file2: null });
				alert("Files uploaded successfully!");
			} else {
				setUploadError("Upload failed. Please try again.");
			}
		} catch (err) {
			setUploadError("An error occurred during upload.");
		} finally {
			setIsUploading(false);
		}
	};






	return (

		<main id="Dashboard">
			<div style={{ display: "flex", flexDirection: "row", marginRight: "16px" }}>
				<h1 style={{ display: 'inline', alignItems: "center" }}>Wahu Bike Maintenance Statistics</h1>
				{isLoading && <span className="loader" style={{ marginLeft: 16 }} />}

				<p style={{ marginLeft: "auto", "fontSize": "small" }}>
					Last Updated: {formatDate(data.last_updated)}
				</p>


			</div>


			<h3 className="stat-row-label">Bikes in Repair</h3>
			<div id="maintenance-stat-row" className="row card-row">
				<StatCard
					label="Total Bikes in Repair (Ghana)"
					value={data.maintenance_summary.total}
				/>
				<StatCard
					label="Pending repair"
					// label="Bikes needing repair"
					value={data.maintenance_summary.maintenance}
				/>
				<StatCard
					label="Ready"
					value={data.maintenance_summary.ready}
				/>
				<StatCard
					label="Awaiting Decommission"
					value={data.maintenance_summary.decommission}
				/>
			</div>

			<h3 className="stat-row-label">Daily Maintenance</h3>
			<div id="stat-stat-row" className="row card-row">
				<StatCard
					label="Total Revenue from components"
					value={formatCurrency(data.summary.total_revenue)}
				/>
				<StatCard
					label="Top Categories Occurances"
					value={topCategories.reduce((sum, cat) => { return sum + cat[1]["occurances"] }, 0)}
				/>
				<StatCard
					label="Revenue from top 5 categories"
					value={formatCurrency(topCategories.reduce((sum, cat) => { return sum + cat[1]["revenue"] }, 0))}
				/>
				<StatCard
					label="Number of unique bikes serviced"
					value={data.summary.unique_bikes}
				/>
				<StatCard
					label="Average Completion Time"
					value={data["summary"]["average_completion_time"]}
				/>
			</div>

			<div className="column">

				<div id="sub-main" className="col">
					<div>
						<div className="row" style={{ justifyContent: "space-between" }}>

							<h3 className="section-header" style={{ display: "inline-block" }}>Week on Week revenue</h3>

						</div>
						<div className="row">



							<div className="stat-graph-div">
								<LineChart className="stat-graph"
									grid={{ vertical: true }}
									xAxis={[{
										data: Object.entries(data.weekly_stats).map((d, i) => {
											// console.log(_)
											let day = d[0].split("-")[0]
											let month = months[Number(d[0].split("-")[1]) - 1]
											return [day, " ", month].join(" ");
										}),
										scaleType: "point",
										label: "Week Date (By Start Date)"
									}]}
									yAxis={[{ label: "Revenue (GHS)" }]}
									series={[{ "data": Object.entries(data.weekly_stats).map((e) => e[1]["revenue"]) }]}
									height={200}
								/>
							</div>
						</div>

					</div>
				</div>
				<div id="sub-main" className="col">
					<div>
						<div className="row" style={{ justifyContent: "space-between" }}>

							<h3 className="section-header" style={{ display: "inline-block" }}>Week on Week Bike Repairs</h3>

						</div>
						<div className="row">
							<div className="stat-graph-div" >
								<LineChart className="stat-graph"
									grid={{ vertical: true }}
									xAxis={[{
										data: Object.entries(data.weekly_stats).map((d, i) => {
											let day = d[0].split("-")[0]
											let month = months[Number(d[0].split("-")[1]) - 1]
											return [day, " ", month].join(" ");
										}),
										scaleType: "point",
										label: "Week Date (By start Date)"
									}]}
									yAxis={[{ label: "Bike Services" }]}
									series={[{ "data": Object.entries(data.weekly_stats).map((e) => e[1]["num_services"]) }]}
									height={200}
								/>
							</div>
						</div>

					</div>
				</div>


				<div className="row" id="tables-div">
					<div style={{ "width": "35%" }}>
						<h4>Top Categories</h4>
						<table>
							<thead>
								<tr>
									<th>Category</th>
									<th>Number of services</th>
									<th>Total Revenue</th>
								</tr>
							</thead>
							<tbody>
								{
									topCategories.map((entry) => {
										return <tr>
											{/* <td>{entry[0]}</td> */}
											<td>{capitalize(entry[0])}</td>
											<td>{entry[1]["occurances"]}</td>
											<td>{entry[1]["revenue"]}</td>
										</tr>
									})
								}
							</tbody>
						</table>
					</div>
					<div style={{ "width": "35%" }}>
						<h4>Top Components</h4>
						<table>
							<thead>
								<tr>
									<th>Component</th>
									<th>Number of services</th>
									<th>Total Revenue</th>
								</tr>
							</thead>
							<tbody>
								{
									topComponents.map((entry) => {
										return <tr>
											{/* <td>{entry[0]}</td> */}
											<td>{capitalize(entry[0])}</td>
											<td>{entry[1]["occurance"]}</td>
											<td>{entry[1]["revenue"]}</td>
										</tr>
									})
								}

							</tbody>
						</table>
					</div>
					<div >
						<h4>Other Statistics</h4>
						<table>
							<thead>
								<tr>
									<th>Item</th>
									<th>Value</th>
								</tr>
							</thead>
							<tbody>
								{
									[{ "Number of repairs": data.summary.num_repairs }, { "Average completion time": data["summary"]["average_completion_time"] }].map((entry) => {
										const _ = Object.keys(entry)[0]
										const __ = entry[_]
										return <tr>
											<td>{_}</td>
											<td>{__}</td>
										</tr>
									})
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>


			{isLoggedIn && (
				<div style={{ position: "fixed", bottom: 20, right: 20 }}>
					<Button
						label="Upload Data"
						color="green"
						onClick={() => setShowUploadPopup(true)}
					/>
				</div>
			)}

			{showUploadPopup && (
				<div className="dialog-overlay" onClick={() => setShowUploadPopup(false)}>
					<div className="dialog" onClick={(e) => e.stopPropagation()} style={{ width: 400 }}>
						<div className="dialog-header">
							<h3>Upload Files</h3>
						</div>
						<div className="dialog-content">
							<form onSubmit={handleUploadSubmit}>
								<div style={{ marginBottom: 16 }}>
									<label>Daily Maintenance Sheet</label>
									<div
										onClick={() => handleBoxClick("file1")}
										onDragOver={(e) => handleDragOver(e, "file1")}
										onDragLeave={(e) => handleDragLeave(e, "file1")}
										onDrop={(e) => handleDrop(e, "file1")}
										style={{
											border: `2px dashed ${dragOver.file1 ? "#4CAF50" : "#ccc"}`,
											borderRadius: 8,
											padding: 32,
											textAlign: "center",
											cursor: "pointer",
											background: dragOver.file1 ? "#f0fdf0" : "#fafafa",
											transition: "all 0.2s",
										}}
									>
										{uploadFiles.file1 ? (
											<p>{uploadFiles.file1.name}</p>
										) : (
											<>
												<p>Drag & drop file here or click to browse</p>
												<p style={{ fontSize: 12, color: "#888" }}>Expected file: Maintenance Journal - 2026.csv</p>
											</>
										)}
									</div>
								</div>
								<div style={{ marginBottom: 16 }}>
									<label>Bike Journal Dasbhoard Sheet</label>
									<div
										onClick={() => handleBoxClick("file2")}
										onDragOver={(e) => handleDragOver(e, "file2")}
										onDragLeave={(e) => handleDragLeave(e, "file2")}
										onDrop={(e) => handleDrop(e, "file2")}
										style={{
											border: `2px dashed ${dragOver.file2 ? "#4CAF50" : "#ccc"}`,
											borderRadius: 8,
											padding: 32,
											textAlign: "center",
											cursor: "pointer",
											background: dragOver.file2 ? "#f0fdf0" : "#fafafa",
											transition: "all 0.2s",
										}}
									>
										{uploadFiles.file2 ? (
											<p>{uploadFiles.file2.name}</p>
										) : (
											<>
												<p>Drag & drop file here or click to browse</p>
												<p style={{ fontSize: 12, color: "#888" }}>Expected file: Bike Journal 2.0 - [Updated] - Dashboard.csv</p>
											</>
										)}
									</div>
								</div>
								{uploadError && <p style={{ color: "red" }}>{uploadError}</p>}
								<div className="dialog-footer" style={{ marginTop: 16 }}>
									<Button type="button" label="Cancel" color="red" onClick={() => setShowUploadPopup(false)} />
									<Button type="submit" label={isUploading ? "Uploading..." : "Upload"} color="green" disabled={isUploading} />
								</div>
							</form>
						</div>
					</div>
				</div>
			)}
		</main>
	)
}

